export const MISSED_TRACKING_LABELS = [
  [
    ['', ''],
    ['', ''],
    ['', '']
  ],
  [
    ['Pending', 'Food has not yet been logged today but was logged on all earlier days (if applicable)'],
    ['Complete', 'Food has been logged on all days'],
    ['Incomplete', 'Food was not logged on one or more days (excluding today)'],
    ['Goal Paused', 'Client\'s goal is paused']
  ],
  [
    ['Pending', 'Food has not yet been logged today but was logged on all earlier days (if applicable) except possibly one'],
    ['Complete', 'Food has been logged on all days except possibly one'],
    ['Incomplete', 'Food was not logged on two or more days (excluding today)'],
    ['Goal Paused', 'Client\'s goal is paused']
  ],
  [
    ['Pending', 'Food has not yet been logged today but was logged on all earlier days (if applicable) except possibly two'],
    ['Complete', 'Food has been logged on all days except possibly two'],
    ['Incomplete', 'Food was not logged on three or more days (excluding today)'],
    ['Goal Paused', 'Client\'s goal is paused']
  ]
]